import { render, staticRenderFns } from "./tip_audio.vue?vue&type=template&id=5474d446&scoped=true&"
import script from "./tip_audio.vue?vue&type=script&lang=js&"
export * from "./tip_audio.vue?vue&type=script&lang=js&"
import style0 from "./tip_audio.vue?vue&type=style&index=0&id=5474d446&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474d446",
  null
  
)

export default component.exports